import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKgQuote2 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 25 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M1 12h8v10H1V12Zm0 0C1 5 2.75 3.344 6 2m8 10h8m-8 0v10h2m-2-10c0-7 1.75-8.656 5-10m.5 13.583c.517-.311 1.275-.559 1.878-.583 1.195 0 2.22.512 2.22 1.878-.015 2.205-4.098 4.78-4.098 4.78V22h4.098"
	})
});
export default SvgKgQuote2;
